import React, { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/hero.png";
import agencyImage from "images/Agency.jpg";
import brandImage from "images/Brand.jpg";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import HeroSearchForm2MobileFactory from "components/HeroSearchForm2Mobile/HeroSearchForm2MobileFactory";
import { connect } from "react-redux";

export interface SectionHeroProps {
  className?: string;
  user?: any;
  userType?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "", user, userType }) => {
  const getContent = () => {
    if (userType === 'agency') {
      return {
        title: "Expand your business here",
        subtitle: "Discover New Brands, Expand Your Portfolio",
        paragraph1: "Looking to grow your brand portfolio with exciting, forward-thinking fashion labels? Our platform connects experienced agents with ambitious brands that are ready to make their mark. Whether you're seeking fresh talent, niche designers, or globally scalable labels, you'll find a curated selection of brands actively looking for representation in new markets.",
        paragraph2: "Join a vibrant network of fashion professionals and open doors to your next big collaboration."
      };
    } else if (userType === 'brand') {
      return {
        title: "Expand your business here",
        subtitle: "Grow Your Reach, Find the Right Representation",
        paragraph1: "You've built something unique—now it's time to get it out into the world. We connect fashion brands with passionate, well-connected agents who understand your market and can take your business to the next level. From regional representation to global expansion, our platform helps you match with the right agents who share your vision.",
        paragraph2: "Expand your footprint, increase sales, and focus on what you do best: creating great fashion"
      };
    } else {
      return {
        title: "Expand your business here",
        subtitle: "",
        paragraph1: "",
        paragraph2: ""
      };
    }
  };

  const getImage = () => {
    switch (userType) {
      case 'agency':
        return agencyImage;
      case 'brand':
        return brandImage;
      default:
        return imagePng;
    }
  };

  const getImageAlt = () => {
    switch (userType) {
      case 'agency':
        return "Agency";
      case 'brand':
        return "Brand";
      default:
        return "hero";
    }
  };

  const content = getContent();
  const heroImage = getImage();
  const imageAlt = getImageAlt();
  
  const isLoading = userType === undefined || userType === null;
  
  return (
    <div
      className={`nc-SectionHero flex flex-col lg:flex-row lg:items-stretch lg:min-h-[600px] justify-between relative pt-4 lg:pt-8 ${className}`}
      data-nc-id="SectionHero"
    >
      {/* Left Side - Content */}
      <div className={`flex-shrink-0 lg:w-1/2 flex flex-col justify-center items-start space-y-6 sm:space-y-8 pb-14 lg:pb-0 pl-4 lg:pl-8 pr-8 lg:pr-12 transition-opacity duration-300 ${isLoading ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
        {userType && (userType === 'agency' || userType === 'brand') ? (
          <>
            <h2 className="font-semibold text-3xl md:text-4xl xl:text-4xl !leading-tight text-black dark:text-white max-w-full lg:max-w-[600px]">
              {content.title}
            </h2>
            <h3 className="text-lg md:text-xl text-black dark:text-white">
              {content.subtitle}
            </h3>
            <div className="text-base md:text-lg text-black dark:text-white space-y-4 text-justify max-w-full lg:max-w-[600px]">
              <p>{content.paragraph1}</p>
              <p><strong>{content.paragraph2}</strong></p>
            </div>
          </>
        ) : (
          <h2 className="font-semibold text-3xl md:text-5xl xl:text-6xl leading-tight text-black dark:text-white">
            {content.title}
          </h2>
        )}

        <div className="hidden md:flex ">
          <HeroSearchForm2MobileFactory />
        </div>
      </div>
      {/* Right Side - Content */}
      <div className={`flex-shrink-0 lg:w-1/2 flex items-center justify-center mt-10 lg:mt-0 lg:py-8 transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`}>
        <div className="w-full h-full flex items-center justify-center">
          <img 
            className="w-full h-auto object-contain max-h-[500px] lg:max-h-[550px]" 
            src={heroImage} 
            alt={imageAlt} 
          />
        </div>
      </div>
      
      {/* loading overlay */}
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white"></div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { })(
  SectionHero
);
